<script setup lang="ts">
    import { computed } from 'vue';
    import { Navigation } from '@/router/navigation';
    import router from '@/router';
    import { Environment, getEnvironment } from '@/util/environment.ts';

    const stageName = computed(() => {
        const env = getEnvironment();
        if (env === Environment.PRODUCTION) {
            return undefined;
        }
        return env;
    });

    async function navigateToChangelog(): Promise<void> {
        await router.push({ name: Navigation.Changelog });
    }
</script>

<template>
    <div v-if="stageName != null" class="stage-badge" :class="stageName" aria-hidden="true">
        <a class="content" @click="navigateToChangelog">{{ stageName }}</a>
    </div>
</template>

<style scoped lang="scss">
    @use '@/styling/main';

    .stage-badge {
        position: fixed;
        left: 0;
        bottom: 0;

        width: 10ch;
        padding: 0 main.$spacing-5;

        text-align: center;
        cursor: pointer;
    }

    .dev {
        background-color: #f97316;
    }

    .staging {
        background-color: #0ea5e9;
    }

    .content {
        text-decoration: none;
        color: main.$color-white;
        font-weight: bold;
    }
</style>
